import { render, staticRenderFns } from "./AssociazioniDisegni.vue?vue&type=template&id=ddf630de&scoped=true&"
import script from "./AssociazioniDisegni.vue?vue&type=script&lang=js&"
export * from "./AssociazioniDisegni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf630de",
  null
  
)

export default component.exports